import styled from "styled-components";
import media from "../media-queries";
import { Link } from "gatsby";

const Item = styled(Link)`
  align-items: center;
  border-bottom: 5px solid ${(props) => props.theme.colours.white};
  color: ${(props) => props.theme.colours.darkGrey};
  display: flex;
  text-decoration: none;
  font-size: 1rem;
  cursor: pointer;
  font-family: ${(props) => props.theme.typography.body.font};
  font-weight: 700;

  &.active {
    border-bottom: 5px solid ${(props) => props.theme.colours.primary};
    border-top: 0;
  }

  &:hover {
    color: ${(props) => props.theme.colours.primary};
  }

  ${media.lg} {
    border-bottom: 0;
    border-top: 5px solid ${(props) => props.theme.colours.white};
    font-size: 0.9rem;
    margin: 0 30px 0 0;

    &.active {
      border-bottom: 0;
      border-top: 5px solid ${(props) => props.theme.colours.primary};
    }
  }

  ${media.xl} {
    font-size: 1rem;
  }
`;

export const MenuLink = (props) => <Item {...props} activeClassName="active" />;

const ShopItem = styled.a`
  align-items: center;
  border-bottom: 5px solid ${(props) => props.theme.colours.white};
  color: ${(props) => props.theme.colours.darkGrey};
  display: flex;
  text-decoration: none;
  font-size: 1rem;
  cursor: pointer;
  font-family: ${(props) => props.theme.typography.body.font};
  font-weight: 700;

  &.active {
    border-bottom: 5px solid ${(props) => props.theme.colours.primary};
    border-top: 0;
  }

  &:hover {
    color: ${(props) => props.theme.colours.primary};
  }

  ${media.md} {
    display: none;
  }
`;

export const ShopLink = (props) => (
  <ShopItem {...props} activeClassName="active">
    {props.children}
  </ShopItem>
);
